import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { MenuBarItem } from '../types';
import { HttpClient } from '@angular/common/http';

import { API_ROOT, TARGET } from '../types/constants/appconstants';

export interface ReleaseComponentInfo {
  BuildNameVersion: string;
  SourceBranch: string;
}

export interface NonProdReleaseAppInfo {
  PCPWebHost: ReleaseComponentInfo;
  PCPScheduleUI: ReleaseComponentInfo;
  PCPRecordables: ReleaseComponentInfo;
  PCPPurchaseOrders: ReleaseComponentInfo;
}

/** Targets where the release-info API is called (QA / non-prod diagnostics). */
const RELEASE_INFO_TARGETS = new Set(['stg', 'qa', 'qa2', 'dev', 'local']);

@Injectable({
  providedIn: 'root'
})
export class AppMenuService {

  private menuItems: MenuBarItem[] = []
  menuItems$: BehaviorSubject<MenuBarItem[]> = new BehaviorSubject(this.menuItems);

  showPOSearch$: BehaviorSubject<boolean> = new BehaviorSubject(false);
  
  constructor() {}

  private http = inject(HttpClient);
  private apiRoot = inject(API_ROOT);
  private target = inject(TARGET);
  private releaseInfoServiceBaseUrl = this.apiRoot + 'api/releaseinfo';

  public setAppMenu(items: MenuBarItem[]): void {
    this.menuItems = items;
    this.menuItems$.next(this.menuItems);
  }

  public showPOSearch(value: boolean): void {
    this.showPOSearch$.next(value);
  }

  public getAppInfo(): Observable<NonProdReleaseAppInfo | null> {
    if (!RELEASE_INFO_TARGETS.has(this.target)) {
      return of(null);
    }
    return this.http.get<NonProdReleaseAppInfo>(this.releaseInfoServiceBaseUrl);
  }
}
